import { useMutation } from '@tanstack/react-query';

import { queryClient, withError } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';
import { notifySuccess } from '@/portainer/services/notifications';

import { RegistryId } from '../../types/registry';

import { updateManifest, getTagManifestV2 } from './manifest.service';
import { queryKeys } from './queryKeys';

export interface CloneTagParams {
  registryId: RegistryId;
  repository: string;
  sourceTag: string;
  targetTag: string;
  environmentId?: EnvironmentId;
}

async function cloneTag({
  registryId,
  repository,
  sourceTag,
  targetTag,
  environmentId,
}: CloneTagParams) {
  // Get the manifest from the source tag
  const manifest = await getTagManifestV2({
    id: registryId,
    repository,
    tag: sourceTag,
    endpointId: environmentId,
  });

  // Remove the digest from the manifest before copying
  const { digest, ...cleanManifest } = manifest;

  // Create the new tag by updating the manifest to the target tag
  await updateManifest(
    {
      id: registryId,
      repository,
      tag: targetTag,
      endpointId: environmentId,
    },
    cleanManifest
  );
}

export function useCloneTag() {
  return useMutation(cloneTag, {
    onSuccess: (_, cloneTagVars) => {
      notifySuccess('Success', 'Tag cloned successfully');
      queryClient.invalidateQueries(
        queryKeys.repositoryTags(
          cloneTagVars.registryId,
          cloneTagVars.repository
        )
      );
    },
    ...withError('Unable to clone tag'),
  });
}
